export const brandData = brand => {
  const data = {
    tempo: {
      displayName: 'Tempo',
      facebookUrl: 'https://www.facebook.com/tempomeals',
      instagramHandle: '@tempomeals',
      signupHeader: 'sign up for Tempo',
      supportPhoneNumber: '+1 (872) 241-1287',
      supportUrl: 'https://support.tempomeals.com/hc/en-us',
    },
    homechef: {
      displayName: 'Home Chef',
      facebookUrl: 'https://www.facebook.com/realhomechef',
      instagramHandle: '@realhomechef',
      signupHeader: 'become a Home Chef',
      supportPhoneNumber: '+1 (872) 225-2433',
      supportUrl: 'https://support.homechef.com/hc/en-us',
    },
  };

  return data[brand];
};
